import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledModalBox = styled(Box)({
  width: '50%',
  height: '97%',
  margin: '1%',
  background: 'white',
  padding: '20px',
  borderRadius: '20px',
});
